module.exports = __webpack_public_path__ + "static/media/image5.7b3d21b9.jpeg";